import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { ADMIN_EMAIL } from '../lib/admin.js';

/**
 * Réserve l'écran d'administration à mon compte. Comme `RequireAuth`, ce n'est
 * qu'un confort d'affichage : le serveur refait le même contrôle sur chaque
 * route `/admin/*` et refuse tout le reste.
 *
 * Reprend la logique de `RequireAuth` plutôt que de l'imbriquer : ses enfants
 * seraient sinon évalués — donc ce composant exécuté — avant même de savoir si
 * `/auth/me` a répondu.
 */
export function RequireAdmin({ children }) {
  const { user, chargement } = useAuth();
  const emplacement = useLocation();

  if (chargement) {
    return (
      <main className="page">
        <p role="status">Chargement…</p>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/connexion" state={{ depuis: emplacement.pathname }} replace />;
  }

  if (user.email !== ADMIN_EMAIL) {
    return <Navigate to="/voyages" replace />;
  }

  return children;
}
